module.exports = __webpack_public_path__ + "img/sponsor_licence.6ad4e7de.png";